import { compose, withProps, onlyUpdateForKeys, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router-dom';
import { isEqual } from 'lodash';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import * as React from 'react';
import WithClassname from '@components/hoc/withClassname/WithClassname';
import RolesAssignForm from '@modules/roles-assing/RolesAssignForm';
import { getAllAssignedRoles } from './_rolesAssignActions';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const rolesAssignUrl = '/metropolis/api/hr/employees';
export const rolesAssignLabel = 'Přiřazení role';
export const rolesAssignPath = '/administration/roles/assignrolesAssign';
export const rolesAssignGridName = 'RolesAssignGrid';
export const RolesAssignGrid = compose(
  withRouter,
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: rolesAssignLabel }]),
  withState('allRoles', 'setAllRoles', []),
  lifecycle<any, any>({
    async componentWillReceiveProps({ location: nextLocation }: any) {
      const { location } = this.props;
      if (!isEqual(location, nextLocation)) {
        const allRoles = await getAllAssignedRoles();
        this.props.setAllRoles(allRoles);
      }
    },
    async componentDidMount() {
      const allRoles = await getAllAssignedRoles();
      this.props.setAllRoles(allRoles);
    }
  }),
  withColumns(Agenda.ROLES_ASSIGN),
  withProps(({ allRoles, columns }) => ({
    name: rolesAssignGridName,
    url: rolesAssignUrl,
    Form: RolesAssignForm,
    dialog: false,
    gridProps: {
      columns,
      allRoles,
      locale: 'cz',
      filterRow: true,
      showCheckboxes: false,
      adding: false,
      editing: true,
      filtering: false,
      version: 2,
      ActionBar: () => <ColumnManager agenda={Agenda.ROLES_ASSIGN} />
    }
  })),
  withAdditionalProps,
  WithClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/roles-assing/RolesAssignGrid.tsx